import { isEmpty } from 'lodash'
import { extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import * as rules from 'vee-validate/dist/rules'

/**
 * Validation
 */
Object.keys(rules).forEach((rule) => {
    extend(rule, rules[rule])
})

extend('required', {
    message: 'Please select an option.',
})

extend('required_alt', {
    ...required,
    message: 'The {_field_} field is required.',
})
